import { useDispatch } from "react-redux";
import styles from "./index.module.css";
import { useState } from "react";
import { setNotes } from "../../../store/slices/popup/popup.slice";
import { Link, NavLink } from "react-router-dom";
import { limitString } from "../../../utils/helpers";

const ProductCard = (props) => {
  const [expand, setExpand] = useState(false);
  const dispatch = useDispatch();

  const toggleExpand = () => setExpand((state) => !state);

  const enableNotes = (e) => {
    dispatch(setNotes({ showNotes: true, notes: e?.target?.dataset?.notes }));
  };

  return (
    <div className={styles["wrapper"]}>
      <div className={styles["container"]}>
        <div className={styles["content"]}>
          <div>
            <div className={styles["title"]}>
              {limitString(props?.title, 23)}
            </div>
            <div className={styles["store"]}>
              {props?.store} {props?.terminal_name && `(${props?.terminal_name})`}
            </div>
          </div>
          <div>
            <div className={styles["label"]}>Price Rank</div>
            <div className={styles["value"]}>{props?.priceRank}</div>
          </div>
          <div>
            <div className={styles["label"]}>Price</div>
            <div className={styles["value"]}>
              {parseFloat(props?.price).toFixed(2)}
            </div>
          </div>
          <div>
            <div className={styles["label"]}>Average</div>
            <div className={styles["value"]}>
              {parseFloat(props?.average).toFixed(2)}
            </div>
          </div>
          <div>
            <div className={styles["label"]}>Difference</div>
            <div className={styles["value"]}>
              {props?.difference?.toFixed(2)}{" "}
              <span>({props?.diffPercentage?.toFixed(2)}%)</span>
            </div>
          </div>
          <Link
            to={`/fnb-price-history/${props?.id}`}
            state={{
              store: props?.store,
              title: props?.title,
              price: parseFloat(props?.price).toFixed(2),
            }}
            className={styles["price-history"]}
          >
            Price History
            <i class="bi bi-box-arrow-up-right"></i>
          </Link>
          <div
            className={
              !expand
                ? styles["breakdown"]
                : styles["breakdown"] + " " + styles["inverse"]
            }
            onClick={toggleExpand}
          >
            Breakdown
            <i class="bi bi-chevron-down"></i>
          </div>
        </div>
      </div>
      {expand && (
        <div className={styles["details"]}>
          {props?.subProducts &&
            props?.subProducts?.map((detail) => {
              return (
                <div
                  className={
                    styles["detail"] +
                    " " +
                    (detail?.store?.toLowerCase() == props?.store?.toLowerCase()
                      ? styles["self"]
                      : "")
                  }
                >
                  <div>{detail?.title}</div>
                  <div>{detail?.store} {detail?.terminal_name && `(${detail?.terminal_name})`}</div>
                  <div>{parseFloat(detail?.price).toFixed(2)}</div>
                  <div>{detail?.priceDifference?.toFixed(2)}</div>
                  <div onClick={enableNotes} data-notes={detail?.notes}>
                    View Note
                  </div>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default ProductCard;
